
import { Button, Typography, Box, Stack, Alert } from '@mui/material'
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom'
import { useIsMobile } from '@/hooks/Responsive'
import { useLang } from '@/i18n/useLang'
import { buildLangHref } from '@data/nav'

export default function RecoverEmailAccount() {
  const { isMobile } = useIsMobile()
  const lang = useLang()
  const location = useLocation();
  const navigate = useNavigate();
  const { sendEmailYn } = location.state || {};

  return (
    <Box>
      <Typography component="h3" variant={isMobile ? 'h6' : 'h5'} sx={{ mb: 7 }}>
        비밀번호 찾기
      </Typography>

      <Stack
        spacing={1.5}
        alignItems="center"
        justifyContent="center"
        sx={{ 
          bgcolor: 'grey.50',
          borderRadius: 4,
          minHeight: '160px',
          py: 3,
          px: 4,
        }}
      >
      {sendEmailYn == 'Y' ? (
        <>
          <Typography component="p" sx={{ textAlign: 'center' }}>
            입력하신 아이디(이메일)로 임시 비밀번호를 발송했습니다.<br />
            로그인 후 [마이페이지]에서 비밀번호를 변경해 주세요.
          </Typography>
          
          <Alert severity="info">
            메일을 받지 못하신 경우, 스팸함을 확인해 주세요.
          </Alert>
        </>
      ) : (
        <Typography component="p" sx={{ textAlign: 'center' }}>
          입력하신 정보에 일치하는 정보가 없습니다.
        </Typography>
      )}
      </Stack>

      <Stack direction="row" spacing={1} sx={{ mt: 5 }}>
        {sendEmailYn == 'Y' ? (
          <>
            <Button component={RouterLink} to={buildLangHref('/', lang)} size="large" variant="outlined" sx={{ flex: 1 }}>홈</Button>
            <Button component={RouterLink} to={buildLangHref('/login', lang)} size="large" variant="contained" sx={{ flex: 1, whiteSpace: 'nowrap' }}>로그인</Button>
          </>
        ) : (
          <>
            <Button component={RouterLink} to={buildLangHref('/', lang)} size="large" variant="outlined" sx={{ flex: 1 }}>홈</Button>
            <Button component={RouterLink} to={buildLangHref('/recoverpassword', lang)} size="large" variant="contained" sx={{ flex: 1, whiteSpace: 'nowrap' }}>다시 찾기</Button>
          </>
        )}
      </Stack>
    </Box>
  )
}